import Nullstack from 'nullstack';
export default function IconContainerOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-container-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 4v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 20v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 16v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 12v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 8v.01"
  }), "   ", Nullstack.element("path", {
    d: "M8.297 4.289a0.997 .997 0 0 1 .703 -.289h6a1 1 0 0 1 1 1v7m0 4v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-11"
  }), "   ", Nullstack.element("path", {
    d: "M4 4v.01"
  }), "   ", Nullstack.element("path", {
    d: "M4 20v.01"
  }), "   ", Nullstack.element("path", {
    d: "M4 16v.01"
  }), "   ", Nullstack.element("path", {
    d: "M4 12v.01"
  }), "   ", Nullstack.element("path", {
    d: "M4 8v.01"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}